import React from 'react';

const NotFoundPage = () => {
  return  <div className="App fade">
  <header className="App-header">
    <h1 className="App-title">
      티켓을 찾을 수 없습니다.
    </h1>
  </header>
  <div className="App-container">
    <div className="group-items">
      <form>
        <div className="box-item">
          <h3 className="item-title">Not found tickets</h3>
          <div className="item-content" style={{height: '90px'}}></div>
        </div>
      </form>
    </div>
  </div>
</div>
};

export default NotFoundPage;


// WEBPACK FOOTER //
// ./src/pages/NotFoundPage.jsx